import React from 'react';

import {PulseLoader} from 'react-spinners';


const Spinner = () => (

    <div className="spinner">

        <PulseLoader color={'#4A4A4A'} size={20} margin={2}/>

    </div>


);

export default Spinner;
